import React, { useEffect, useState } from "react";

// Splash screen a tutto schermo all'avvio: logo Velta One bianco su navy, 2s + fade-out
export const SplashScreen = ({ onDone }) => {
  const [fading, setFading] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 2000);
    const t2 = setTimeout(() => onDone?.(), 2500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);
  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center transition-opacity duration-500 ${fading ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      style={{ background: "#1E2D5B" }}
    >
      <img src="/velta-one-mark-white.png" alt="Velta One" className="w-44 h-24 object-contain splash-in" />
      <div className="mt-6 font-heading font-extrabold tracking-tight text-3xl text-white splash-in" style={{ animationDelay: "0.15s" }}>
        Velta One
      </div>
      <div className="mt-2 text-[10px] font-mono uppercase tracking-[0.35em] text-white/40 splash-in" style={{ animationDelay: "0.3s" }}>
        by VELTA SISTEMI
      </div>
    </div>
  );
};
